module.exports = __webpack_public_path__ + "static/media/matilde-hat-sri-lanka-happy.3320872d.png";